<template>
  <div class="c-justify-center c-md:c-justify-start c-items-center c-md:c-items-start">
    <form @submit.prevent="submitForm">
      <input
        id="product-link"
        v-model="form.email"
        type="email"
        class="form-control form-control-md text-left c-rounded-sm"
        :placeholder="t('your_email')"
        required
      >
      <p class="c-mt-2">
        {{ t('write_your_email') }}
      </p>
      <div class="flex c-justify-center">
        <button
          :disabled="formIsSubmitting"
          class="btn btn-success c-mr-2  c-rounded-pill font-medium"
          type="submit"
        >
          {{ t('enter_an_email') }}
        </button>
        <button
          class="btn btn-danger  c-rounded-pill font-medium"
          type="button"
          @click="closeModal"
        >
          {{ t('cancel') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import ApiServiceV1 from '@/api/adminApi/AdminApiV1'
import { useModalStore } from '@/stores/ModalStore'

const router = useRouter()
const { t } = useI18n()

const modalStore = useModalStore()
const { getParams } = storeToRefs(modalStore)

const form = ref({
  email: undefined,
})
const formIsSubmitting = ref(false)

const closeModal = () => {
  modalStore.closeModal()
}

const submitForm = (event) => {
  if (event.target.checkValidity() === false) {
    event.preventDefault()
    event.stopPropagation()
    event.target.querySelector(':invalid:not(fieldset)').focus()
  } else {
    processForm()
  }
}

const processForm = async () => {
  formIsSubmitting.value = true

  const path = router
    .resolve({ name: 'productPath', params: { permalink: getParams.value.product.permalink } })
    .fullPath.slice(1)

  const productUrl = `${import.meta.env.VITE_VUE_APP_ORIGINAL_URL}${path}`

  try {
    const { data } = await ApiServiceV1.post('watchdogs', {
      watchdog: {
        product_id: getParams.value.product.id,
        product_url: productUrl,
        email: form.value.email,
      },
    })
    formIsSubmitting.value = false
    modalStore.openModal({ id: 'modal-alert', title: data.msg })
  } catch {
    formIsSubmitting.value = false
    // const errorMessage = error.response.data.msg
    // scrollToInfoList()
  }
}
</script>

<i18n>
  {
    "cs": {
    "cancel": "Zrušit",
    "enter_an_email": "Vložte e-mail",
    "write_your_email": "Napište svůj e-mail a Hlídací ptáček pípne, jakmile bude naskladněno.",
    "your_email": "Váš e-mail"
},
    "sk": {
    "cancel": "Zrušiť",
    "enter_an_email": "Vložte email",
    "write_your_email": "Napíšte svoj e-mail a Strážny vtáčik pípne hneď, ako bude naskladnené.",
    "your_email": "Váš email"
},
    "pl": {
    "cancel": "Anuluj",
    "enter_an_email": "Zatwierdź",
    "write_your_email": "Podaj swój e-mail a nasz Ptaszek zaćwierka Ci, jak tylko produkt będzie znów dostępny :)",
    "your_email": "Twój e-mail"
},
    "hu": {
    "cancel": "Mégse",
    "enter_an_email": "E-mail cím elmentése",
    "write_your_email": "Add meg az e-mail címed és a figyelő madár csipogni fog, amint a termék raktáron lesz",
    "your_email": "Az e-mailed"
},
    "de": {
    "cancel": "Abbrechen",
    "enter_an_email": "E-Mail einfügen",
    "write_your_email": "Gib deine E-Mail-Adresse ein und unser Mixit-Vogel zwitschert dir,  sobald das Produkt wieder verfügbar ist :)",
    "your_email": "Deine E-Mail"
},
    "at": {
    "cancel": "Abbrechen",
    "enter_an_email": "E-Mail einfügen",
    "write_your_email": "Gib deine E-Mail-Adresse ein und unser Mixit-Vogel zwitschert dir,  sobald das Produkt wieder verfügbar ist :)",
    "your_email": "Deine E-Mail"
},
    "ro": {
    "cancel": "Anulează",
    "enter_an_email": "Introdu emailul",
    "write_your_email": "Introduceți adresa dvs. de e-mail și pasărea Mixit te va avertiza când va fi în stoc. :)",
    "your_email": "Emailul tău"
},
    "fr": {
    "cancel": "Annuler",
    "enter_an_email": "Saisissez votre adresse e-mail",
    "write_your_email": "Laissez votre e-mail et le petit oiseau gardien vous avertira dès que le produit sera de nouveau en stock.",
    "your_email": "Votre e-mail"
},
    "it": {
    "cancel": "Cancellare",
    "enter_an_email": "Inserisci la tua e-mail.",
    "write_your_email": "Inserisci la tua e-mail e l’Uccellino Guardiano cinguetterà appena il prodotto sarà di nuovo disponibile.",
    "your_email": "La tua e-mail"
}
  }
</i18n>
